import { Trans } from 'react-i18next'
import cn from 'clsx'

import formatUINumber from '../../utils/format_ui_number'
import { CLASS_NAME } from './const'

type Props = {
  groupTotalNEE: number
  groupTotalArea: number
}

export default function GroupInfo({ groupTotalNEE, groupTotalArea }: Props) {
  const groupIntensity = groupTotalNEE / groupTotalArea

  return (
    <ul className={`${CLASS_NAME}-values`}>
      <li className={`${CLASS_NAME}-values-intensity`}>
        <p>
          <Trans i18nKey="group_list_item.intensity_row_label">Intensity</Trans>
        </p>
        <p
          className={cn({
            negative: groupIntensity < 0,
            positive: groupIntensity >= 0
          })}
        >
          {formatUINumber(groupIntensity)} T/ha
        </p>
      </li>
      <li className={`${CLASS_NAME}-values-nee`}>
        <p>
          <Trans i18nKey="group_list_item.nee_row_label">Total NEE</Trans>
        </p>
        <p
          className={cn({
            negative: groupTotalNEE < 0,
            positive: groupTotalNEE >= 0
          })}
        >
          {formatUINumber(groupTotalNEE / 1000)} kT
        </p>
      </li>
      <li className={`${CLASS_NAME}-values-area`}>
        <p>
          <Trans i18nKey="group_list_item.area_row_label">Total Area</Trans>
        </p>
        <p>{formatUINumber(groupTotalArea)} Ha</p>
      </li>
    </ul>
  )
}
